module.exports = __webpack_public_path__ + "img/logo.cac5a06f.svg";